import PageHeader from "../common/pageHeader/v2";
import Team from "../components/section/team/v1";

const TeamPage = () => {
  return (
    <>
      <PageHeader title="teams" subTitle="teams" />
      <Team />
    </>
  );
};

export default TeamPage;
